import { Link } from 'react-router-dom';
import { RivlLogo } from '../components/common/RivlLogo';
import { ThemeToggle } from '../components/common/ThemeToggle';
import { Button } from '../components/ui/button';
import { ArrowRight, Smartphone } from 'lucide-react';

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground rivl-noise">
      <header className="border-b border-border">
        <div className="mx-auto max-w-6xl px-6 py-5 flex items-center justify-between">
          <RivlLogo size="lg" variant="wordmark" />
          <div className="flex items-center gap-3">
            <span className="rivl-label hidden md:inline">Race Identity & Verification Layer</span>
            <ThemeToggle />
          </div>
        </div>
        <div className="h-1 flex">
          <div className="flex-1 bg-primary" />
          <div className="flex-1 bg-card" />
          <div className="flex-1 bg-brand-blue" />
        </div>
      </header>

      <section className="mx-auto max-w-6xl px-6 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-6 items-end">
          <div className="md:col-span-8">
            <span className="rivl-label">v0.1 · MVP</span>
            <h1 className="mt-3 font-display font-black text-5xl md:text-7xl tracking-[-0.04em] leading-[0.95]">
              Structure, identity<br />and trust for<br />real-world races.
            </h1>
          </div>
          <div className="md:col-span-4">
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Run, race, and verify. RIVL brings clarity and integrity to physical events — start tracking your next race below.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-24">
        <div className="grid md:grid-cols-3 gap-4">
          <Link
            to="/auth"
            data-testid="enter-mobile"
            className="group rivl-card p-6 flex flex-col gap-6 hover:border-primary transition-colors md:col-span-1"
          >
            <div className="h-10 w-10 rounded-md flex items-center justify-center bg-primary text-primary-foreground">
              <Smartphone className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-display text-2xl font-bold tracking-tight">Open RIVL</h3>
              <p className="mt-2 text-sm text-muted-foreground">Run, race, scan medals. The runner & scanner experience.</p>
            </div>
            <div className="mt-auto flex items-center gap-2 text-sm font-medium group-hover:text-primary">
              Get started <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </div>
          </Link>

          <div className="rivl-card p-5 md:col-span-1">
            <div className="rivl-label">01</div>
            <div className="mt-2 font-display text-lg font-semibold">Personal Runs</div>
            <p className="mt-1 text-muted-foreground text-sm">Lightweight tracking. No verification layer.</p>
          </div>
          <div className="rivl-card p-5 border-primary md:col-span-1">
            <div className="rivl-label text-primary">02</div>
            <div className="mt-2 font-display text-lg font-semibold">Verified Races</div>
            <p className="mt-1 text-muted-foreground text-sm">Structured. Verified. High-integrity finishes.</p>
          </div>
        </div>
      </section>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-6xl px-6 py-6 flex items-center justify-between text-xs text-muted-foreground">
          <span>© RIVL 2026</span>
          <Button variant="link" size="sm" className="px-0" asChild>
            <Link to="/auth" data-testid="enter-app-link">Sign in →</Link>
          </Button>
        </div>
      </footer>
    </div>
  );
}
